import { defineComponent } from 'vue';
export default defineComponent({
    name: 'BikeLaneInfoCard',
    props: {
        info: {
            type: Object,
            default: function () { return ({}); }
        }
    },
    setup: function () {
        var filterDistance = function (distance) {
            return distance ? (distance / 1000).toFixed(2) : '-';
        };
        return {
            filterDistance: filterDistance
        };
    },
});
